import { useState } from 'react';
import { Outlet } from 'react-router';
import { useIsAuthenticated } from 'features/auth';
import { FetchUser } from 'features/users';

type P = {
  useInitialAuthState?: boolean;
};

const FetchUserGuard = ({ useInitialAuthState = false }: P) => {
  const isAuthenticated = useIsAuthenticated();
  // eslint-disable-next-line react/hook-use-state -- We want to set this state only once
  const [isInitialAuthenticated] = useState(isAuthenticated);

  const shouldFetchUser = useInitialAuthState ? isInitialAuthenticated : isAuthenticated;

  if (shouldFetchUser) {
    return <FetchUser />;
  }

  return <Outlet />;
};

export default FetchUserGuard;
